class StickyProductBar extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.observeSections = this.observeSections.bind(this);
    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
  }

  connectedCallback() {
    this.productSection = document.getElementById('main-product-section');
    this.navLinks = this.querySelectorAll('.section-tab');
    this.productCard = this.closest('product-card');
    this.stickyProductVariant = this.querySelector('.sticky-bar-variant');
    this.footer = document.querySelector('footer');
    this.product_ATC = document.querySelector('.ATC-main-prod')

    if (this.stickyProductVariant && this.productCard) {
      this.observeVariantChanges();
    }

    if (this.productSection) {
      window.addEventListener('scroll', this.handleScroll);
    }

    const sectionIds = Array.from(this.navLinks)
      .map((link) => link.getAttribute('href'))
      .filter((href) => href && href.startsWith('#'))
      .map((href) => document.querySelector(href))
      .filter((section) => section);

    this.sections = sectionIds;

    if (this.sections.length > 0) {
      this.initObserver();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.observer) {
      this.sections.forEach((section) => this.observer.unobserve(section));
    }
    if (this.variantObserver) {
      this.variantObserver.disconnect();
    }
  }

handleScroll() {
  if (!this.productSection) return;
  
  
  const footerRect = this.footer.getBoundingClientRect();
  const productSectionRect = this.productSection.getBoundingClientRect();
  const isMobile = window.innerWidth < 768;
  
  // Check if the add to cart section is in view
  let addToCartSectionInView = false;
  if (this.product_ATC) {
    const rect = this.product_ATC.getBoundingClientRect();
    addToCartSectionInView = 
      rect.top < window.innerHeight && 
      rect.bottom > 0;
  }
  
  // Don't show sticky bar if the section is in view
  if (addToCartSectionInView) {
    this.classList.remove('active-sticky');
    return;
  }
  

  if (isMobile) {
    if (productSectionRect.top < 0 && footerRect.top > window.innerHeight) {
      this.classList.add('active-sticky');
    } else {
      this.classList.remove('active-sticky');
    }
  } else {
    if (footerRect.top <= (window.innerHeight || document.documentElement.clientHeight)) {
      this.classList.remove('active-sticky');
    } else if (productSectionRect.bottom <= 400) {
      this.classList.add('active-sticky');
    } else {
      this.classList.remove('active-sticky');
    }
  }
}

  initObserver() {
    this.observer = new IntersectionObserver(this.observeSections, {
      threshold: 0.6,
    });

    this.sections.forEach((section) => {
      this.observer.observe(section);
    });
  }

  observeSections(entries) {
    entries.forEach((entry) => {
      const id = entry.target.id;

      if (entry.isIntersecting) {
        this.navLinks.forEach((link) => {
          link.classList.remove('active-section');
          if (link.getAttribute('href') === `#${id}`) {
            link.classList.add('active-section');
          }
        });
      }
    });
  }

  observeVariantChanges() {
    this.variantObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant') {
          this.handleVariantUpdate();
        }
      }
    });

    this.variantObserver.observe(this.productCard, {
      attributes: true,
      attributeFilter: ['data-product-card-selected_variant'],
    });
  }

  handleVariantUpdate() {
    const variant = this.productCard.getAttribute('data-product-card-selected_variant');
    if (!variant) return;

    try {
      const variantData = JSON.parse(variant);
      this.stickyProductVariant.textContent = variantData.title;
    } catch (error) {
      console.error('Failed to parse variant data:', error);
    }
  }
}

window.customElements.define('sticky-product-bar', StickyProductBar);
